import React from "react"
import Modal from "react-bootstrap/lib/Modal"

import CartContainer from "../CartContainer"

import { SET_CART_VISIBILITY } from "../stores/CartStateStore"

export default function CartSummaryModal(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const {
    orderingEnabled,
    minGoodsPrice,
    latitude,
    longitude,
    cartState,
    dispatchCartState,
    maxCashAmountCents
  } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  function handleClose() {
    dispatchCartState({ type: SET_CART_VISIBILITY, payload: false })
  }

  function renderModalBody() {
    return (
      <CartContainer
        padded
        storeId={cartState.store_id}
        cartState={cartState}
        dispatchCartState={dispatchCartState}
        latitude={latitude}
        longitude={longitude}
        orderingEnabled={orderingEnabled}
        minGoodsPrice={minGoodsPrice}
        isModal={true}
        maxCashAmountCents={maxCashAmountCents}
      />
    )
  }

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  // -------------------------------------

  return (
    <Modal
      show={cartState.visible}
      onHide={handleClose}
      onExited={handleClose}
      className="modal modal--full-height cart-summary-modal"
      animation={true}
    >
      <Modal.Header>
        <Modal.Title>
          {I18n.t("cart")}
        </Modal.Title>
        <button
            className="close"
            aria-label="Close"
            data-dismiss="modal"
            type="button"
            onClick={handleClose}
          >
            <i className="fal fa-times" />
        </button>
      </Modal.Header>
      <Modal.Body>{renderModalBody()}</Modal.Body>
    </Modal>
  )
}
